import { KeyOption, matchSorter } from 'match-sorter';

export default function fuzzyComplete<T = unknown>(
  keys: ReadonlyArray<KeyOption<T>>,
  config: {
    baseSort?: (a: any, b: any) => number;
    sorter?: (items: { item: T; rank: number }[]) => T[];
    filter?: (options: any) => any;
    threshold?: (typeof matchSorter.rankings)[keyof typeof matchSorter.rankings];
  } = {}
) {
  return (options, { inputValue }) => {
    const terms = inputValue.split(' ');

    if (!terms) {
      return options;
    }

    const filteredOptions = config.filter ? config.filter(options) : options;

    return terms.reduceRight(
      (options, term) =>
        matchSorter<T>(filteredOptions, term, {
          keys,
          sorter: config.sorter,
          baseSort: options.baseSort,
          threshold: config.threshold,
        }),
      filteredOptions
    );
  };
}
